import { AppTheme } from 'core/Theme'
import React, { useEffect, useState } from 'react'

const AppLogo: React.FC = () => {
  const [logoUrl, setLogoUrl] = useState<string | null>(null)

  useEffect(() => {
    // For web/PWA, load logos from public/assets/logos
    // Files in public/ are served as static assets and not processed by webpack
    // This prevents logos from being included in chunks
    const logoPath = `/assets/logos/${AppTheme.logoUrl}`
    setLogoUrl(logoPath)
  }, [])

  return logoUrl ? <img src={logoUrl} alt="Logotipo" /> : null
}

export default AppLogo
